import React from 'react';
import { DEFAULT_WHTS } from 'src/types/WarehouseHandlingTier';

interface HandlingTierSelectorProps {
    selectedTier: string;
    onTierChange: (tier: string) => void;
    availableTiers?: string[];
}

export const HandlingTierSelector: React.FC<HandlingTierSelectorProps> = ({
    selectedTier,
    onTierChange,
    availableTiers
}) => {
    // Use provided tiers or fall back to default WHTs
    const handlingTiers = (availableTiers ?? DEFAULT_WHTS).filter(
        value => typeof value === 'string'
    ) as string[];

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        onTierChange(event.target.value);
    };

    return (
        <div className="handling-tier-selector" style={{ marginBottom: '16px', display: 'flex', alignItems: 'center' }}>
            <label htmlFor="handling-tier-select" style={{ marginRight: '8px', fontWeight: 'bold' }}>
                Handling Tier:
            </label>
            <select
                id="handling-tier-select"
                value={selectedTier}
                onChange={handleChange}
                style={{ 
                    minWidth: '200px',
                    padding: '4px 8px',
                    fontSize: '14px',
                    border: '1px solid #ccc',
                    borderRadius: '4px'
                }}
            >
                {handlingTiers.map(tier => (
                    <option key={tier} value={tier}>
                        {tier}
                    </option>
                ))}
            </select>
        </div>
    );
};
